import React, { useState } from 'react';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';
import classnames from 'classnames/bind';

import StarsIco from '../shared/icons/StarsIco';
import ConditionsPopin from '../ConditionsPopin';
import CollapsedSection from '../CollapsedSection';
import {pushBasketInteractAction} from '../../helpers/gtm';

import styles from './BasketInfo.module.scss';

const cx = classnames.bind(styles);

const BasketInfo = ({
  data: {
    title: subtitle,
    stars,
    apartments,
    payment: {
      total: {
        label: totalLabel,
        price: totalPrice,
        subtitle: totalSubtitle,
      },
      hotel: paymentHotel,
      prepay: paymentPrepay,
    },
    paymentDetails: {
      title: detailsTitle,
      nights,
      taxIncluded,
      benefit,
      notIncludedTitle,
      taxNotIncluded,
      optionsTitle,
      options,
    },
  },
  reminderInfo,
  popInConditions,
  isTitleDisplay = false,
  isTotalPriseDisplay = false,
  isDetailsOpened = false,
  isReminderInfoDisplay = false,
  className,
}) => {
  const [isOpenedDetails, setIsOpenedDetails] = useState(isDetailsOpened);
  const [showPopin, setShowPopin] = useState(false);

  const handleConditionsPopin = () => {
    pushBasketInteractAction('see all terms and conditions')
    setShowPopin(!showPopin);
  };

  const toggleDetails = () => {
    pushBasketInteractAction(isOpenedDetails ? 'hide billing details' : 'show billing details');
    setIsOpenedDetails(!isOpenedDetails)
  }

  const onClickHandler = () => handleConditionsPopin();

  const renderBody = () => (
    <>
      <div className={cx('header')}>
        <div className={cx('subtitle')}>{subtitle}</div>
        <div className={cx('rating')}>
          <StarsIco stars={stars} />
        </div>
      </div>
      <ul className={cx('apartments')}>
        { apartments.map(({rates, details, personDates, roomType, label}, i) => (
          <CollapsedSection
            label={label}
            tag="li"
            className={cx('body', {'simple': apartments.length < 2})}
            open={apartments.length < 2}
            key={`Apartment${i+1}`}
            togglerLabel={details}
          >
            <div className={cx('rates')}>
              <div className={cx('rates-text')}>{rates}</div>
              <div
                className={cx('rates-info')}
                role="button"
                tabIndex="0"
                /* eslint-disable-next-line @typescript-eslint/no-empty-function */
                onKeyDown={() => {}}
                onClick={onClickHandler}
              >
                {details}
              </div>
              {showPopin && Object.keys(popInConditions).length > 0 && (
                <ConditionsPopin
                  popInConditions={popInConditions}
                  handleConditionsPopin={handleConditionsPopin}
                />
              )}
            </div>
            {personDates && (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
              <div className={cx('personDates')}>{personDates}</div>
            )}
            {roomType && (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
              <div className={cx('roomType')}>{roomType}</div>
            )}
          </CollapsedSection>
        ))}
      </ul>
    </>
  );

  const renderDetailsEntry = () => {
    return (
      <div className={cx('details-entry')}>
        {nights && Object.keys(nights).length > 0 && (
          <div className={cx('details-row')}>
            <div className={cx('details-col')}>{nights.title}</div>
            <div className={cx('details-col')}>{nights.price}</div>
          </div>
        )}
        {options && options.length ? (
          <div className={cx('details-row')}>
            <div className={cx('details-col')}>{optionsTitle}</div>
          </div>
        ) : null}
        {options && options.length
          ? options.map((item, i) => {
            return (
              <div key={uuid()} className={cx('details-row')}>
                <div className={cx('details-col')}>{item.title}</div>
                <div className={cx('details-col')}>{item.price}</div>
              </div>
            );
          })
          : null}
        {taxIncluded && Object.keys(taxIncluded).length > 0 && (
          <div className={cx('details-row')}>
            <div className={cx('details-col')}>{taxIncluded.title}</div>
            <div className={cx('details-col')}>{taxIncluded.price}</div>
          </div>
        )}
        {notIncludedTitle && taxNotIncluded && taxNotIncluded.length ? (
          <div className={cx('details-row')}>
            <div className={cx('details-col')}>{notIncludedTitle}</div>
            {taxNotIncluded.map((item, i) => {
              return (
                <div key={uuid()} className={cx('details-col')}>
                  {item.price}
                </div>
              );
            })}
          </div>
        ) : null}
        {benefit && Object.keys(benefit).length > 0 && (
          <div className={cx('details-row')}>
            <div className={cx('details-col')}>{benefit.title}</div>
            <div className={cx('details-col')}>{benefit.price}</div>
          </div>
        )}
        <div className={cx('footer')}>
          {/* eslint-disable-next-line */}
          <div className={cx('footer-label')}>{totalLabel}:</div>
          <div className={cx('footer-price')}>{totalPrice}</div>
        </div>
      </div>
    );
  };

  return (
    <div className={cx('root', className)}>
      {isTitleDisplay && (<div className={cx('title')}>Votre séjour</div>)}
      {renderBody()}
      {isTotalPriseDisplay && (
        <div>
          <div className={cx('total')}>
            <div className={cx('total-label')}>{totalLabel} :</div>
            <div className={cx('total-price')}>{totalPrice}</div>
          </div>
          <div className={cx('total-subtitle')}>{totalSubtitle}</div>
        </div>
      )}
      {paymentHotel?.label && (
        <div className={cx('hotel')}>
          {/* eslint-disable-next-line */}
          <div className={cx('hotel-label')}>{paymentHotel.label}</div>
          <div className={cx('hotel-price')}>{paymentHotel.price}</div>
        </div>
      )}
      {paymentPrepay ? (
        <div className={cx('prepay')}>
          {/* eslint-disable-next-line */}
          <div className={cx('prepay-label')}>{paymentPrepay.label}</div>
          <div className={cx('prepay-price')}>{paymentPrepay.price}</div>
        </div>
      ) : null}
      <div className={cx('details')}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div
          onClick={toggleDetails}
          className={cx('details-header', {active: isOpenedDetails})}
        >
          <div className={cx('details-title')}>{detailsTitle}</div>
          <div className={cx('details-arrow')}>
            {/* eslint-disable-next-line */}
          </div>
        </div>
        {isOpenedDetails ? renderDetailsEntry() : null}
      </div>
      {isReminderInfoDisplay && reminderInfo?.prompt && (
        <div className={cx('reminderInfo')}>
          <img src={reminderInfo.prompt.img} alt="" />
          <p>
            <span>{reminderInfo.prompt.text.accentText}</span>
            {reminderInfo.prompt.text.text}
          </p>
        </div>
      )}
    </div>
  );
};

BasketInfo.propTypes = {
  reminderInfo: PropTypes.shape({}).isRequired,
  popInConditions: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({}).isRequired,
  isTitleDisplay: PropTypes.bool,
  isTotalPriseDisplay: PropTypes.bool,
  isDetailsOpened: PropTypes.bool,
  isReminderInfoDisplay: PropTypes.bool,
};

BasketInfo.defaultProps = {
  isTitleDisplay: false,
  isTotalPriseDisplay: false,
  isDetailsOpened: false,
  isReminderInfoDisplay: false,
}

export default BasketInfo;
